export const rateCardsURLSByLanguage: Record<string, string> = {
    'en': 'https://cdn.thinkwebcontent.com/assets/thinkspain/docs/thinkSPAIN-Advertising-Price-List.pdf',
    'es': 'https://cdn.thinkwebcontent.com/assets/thinkspain/docs/thinkSPAIN-Advertising-Price-List-ES.pdf',
};
